import { useState } from 'react';
import { trackEvent } from '@/lib/analytics';

interface ShareButtonsProps {
  ideaId: string;
  text: string;
  compact?: boolean;
}

const SITE = 'https://dumbverse.app';
const FUNCTIONS_URL = `${import.meta.env.VITE_SUPABASE_URL}/functions/v1`;

const ShareButtons = ({ ideaId, text, compact }: ShareButtonsProps) => {
  const [copied, setCopied] = useState(false);
  const url = `${FUNCTIONS_URL}/idea-preview?id=${encodeURIComponent(ideaId)}`;
  const short = text.length > 140 ? `${text.slice(0, 137)}...` : text;
  const message = `"${short}" — seen on DUMBVERSE`;

  const open = (href: string, platform: string) => {
    trackEvent('idea_shared', { platform, ideaId });
    window.open(href, '_blank', 'noopener,noreferrer');
  };

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(`${message}\n${url}`);
      setCopied(true);
      trackEvent('idea_shared', { platform: 'copy', ideaId });
      setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  };

  const nativeShare = async () => {
    if (!navigator.share) return copy();
    try {
      await navigator.share({ title: 'DUMBVERSE', text: message, url });
      trackEvent('idea_shared', { platform: 'native', ideaId });
    } catch {
      /* dismissed */
    }
  };

  const btn =
    'px-3 py-1.5 rounded border border-border bg-card/60 text-muted-foreground hover:text-foreground hover:border-primary/50 font-mono text-xs transition-colors';

  return (
    <div className={`flex flex-wrap items-center gap-2 ${compact ? '' : 'mt-3'}`}>
      <button
        type="button"
        className={btn}
        onClick={() => open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(message)}&url=${encodeURIComponent(url)}`, 'x')}
      >
        X
      </button>
      <button
        type="button"
        className={btn}
        onClick={() => open(`https://wa.me/?text=${encodeURIComponent(`${message} ${url}`)}`, 'whatsapp')}
      >
        WhatsApp
      </button>
      <button
        type="button"
        className={btn}
        onClick={() => open(`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`, 'linkedin')}
      >
        LinkedIn
      </button>
      <button
        type="button"
        className={btn}
        onClick={() => open(`https://www.reddit.com/submit?url=${encodeURIComponent(url)}&title=${encodeURIComponent(short)}`, 'reddit')}
      >
        Reddit
      </button>
      <button
        type="button"
        className={btn}
        onClick={() => open(`https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(message)}`, 'telegram')}
      >
        Telegram
      </button>
      <button type="button" className={btn} onClick={nativeShare}>
        {copied ? 'Link copied ✓' : 'Copy link'}
      </button>
    </div>
  );
};

export default ShareButtons;
